<template>
  <div class="districtProvider district-provider-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select
        v-model="params.discType"
        size="small"
        placeholder="请选择商区类型"
        @change="getDistrictList()"
        clearable
      >
        <el-option
          v-for="(item, i) in discTypeList"
          :value="item.value"
          :label="item.label"
          :key="i"
        ></el-option>
      </el-select>
      <el-input
        placeholder="商区码"
        size="small"
        @clear="getDistrictList"
        class="param-input"
        v-model="params.districtCode"
        @change="getDistrictList()"
        clearable
      ></el-input>
      <el-input
        placeholder="用户名"
        size="small"
        @clear="getDistrictList"
        class="param-input"
        v-model="params.name"
        @change="getDistrictList()"
        clearable
      ></el-input>
      <el-input
        placeholder="手机号码"
        size="small"
        @clear="getDistrictList"
        class="param-input"
        v-model="params.mobile"
        @change="getDistrictList()"
        clearable
      ></el-input>
      <el-input
        placeholder="备注"
        size="small"
        @clear="getDistrictList"
        class="param-input"
        v-model.number="params.remark"
        @change="getDistrictList()"
        clearable
      ></el-input>
      <el-button type="primary" size="small" @click="getDistrictList('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="addDistrict">添加</el-button>
      <div>
        <el-checkbox v-model="checked" @change="getDistrictList('status')">显示子渠道</el-checkbox>
      </div>
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      ref="multipleTable"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="620"
    >
      <el-table-column prop="districtCode" label="商区码" align="center" width="150" fixed>
        <template slot-scope="scope">
          <p v-if="scope.row.parent" style="background: #FF9300; color: white;">{{scope.row.parent}}</p>
          <p>{{ scope.row.districtCode }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="discType" label="商区类型" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.discType | handleFilterDiscType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="用户名" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="mobile" label="手机号码" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="password" label="用户密码" align="center" min-width="120">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.password }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag type="info" size="medium">查看密码</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="inviteLink"
        label="邀请链接"
        align="center"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <el-button type="primary" @click="showLink(scope.row)" size="mini">查看推广链接</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="余额/元" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.balance || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.remark || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="添加时间" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="disable" label="启用商区" align="center" min-width="100">
        <template slot-scope="scope">
          <span>
            <el-switch
              :value="!scope.row.disable"
              active-color="#13ce66"
              inactive-color="#666666"
              :active-text="!scope.row.disable ? '是' : '否'"
              disabled
            ></el-switch>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="lock" label="允许登陆" align="center" min-width="100">
        <template slot-scope="scope">
          <span>
            <el-switch
              :value="!scope.row.lock"
              active-color="#13ce66"
              inactive-color="#666666"
              :active-text="!scope.row.lock ? '是' : '否'"
              disabled
            ></el-switch>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="disTrans" label="允许提现" align="center" min-width="100">
        <template slot-scope="scope">
          <span>
            <el-switch
              :value="!scope.row.disTrans"
              active-color="#13ce66"
              inactive-color="#666666"
              :active-text="!scope.row.disTrans ? '是' : '否'"
              disabled
            ></el-switch>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="disAd" label="允许广告" align="center" min-width="100">
        <template slot-scope="scope">
          <span>
            <el-switch
              :value="!scope.row.disAd"
              active-color="#13ce66"
              inactive-color="#666666"
              :active-text="!scope.row.disAd ? '是' : '否'"
              disabled
            ></el-switch>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="disSettlement" label="允许结算" align="center" min-width="100">
        <template slot-scope="scope">
          <span>
            <el-switch
              :value="!scope.row.disSettlement"
              active-color="#13ce66"
              inactive-color="#666666"
              :active-text="!scope.row.disSettlement ? '是' : '否'"
              disabled
            ></el-switch>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="disMulDivi" label="允许多级分成" align="center" min-width="100">
        <template slot-scope="scope">
          <span>
            <el-switch
              :value="!scope.row.disMulDivi"
              active-color="#13ce66"
              inactive-color="#666666"
              :active-text="!scope.row.disMulDivi ? '是' : '否'"
              disabled
            ></el-switch>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="deductType" label="扣量方式" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.deductType | deductionType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nuDeductionRatio" label="用户扣量比例" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ (scope.row.nuDeductionRatio*100).toFixed(2) || "0" }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="rechgDeductionRatio" label="充值扣量比例" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ (scope.row.rechgDeductionRatio*100).toFixed(2) || "0" }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="operating" fixed="right" label="操作" align="center" min-width="300">
        <template slot-scope="scope">
          <div style="operating">
            <div class="operating">
              <el-button
                class="flex-item"
                type="success"
                size="mini"
                icon="el-icon-edit"
                @click="Action(scope.row)"
              >编 辑</el-button>
              <el-button
                class="flex-item"
                :type="scope.row.disable ? 'success' : 'danger'"
                size="mini"
                @click="ban(scope.row)"
              >{{ scope.row.disable ? "启 用" : "禁 用" }}</el-button>
              <el-button
                class="flex-item"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                @click="remove(scope.row.id)"
              >删 除</el-button>
              <el-button class="flex-item" size="mini" @click="statDialy(scope.row)">每日统计</el-button>
              <el-button class="flex-item" size="mini" @click="widthdraw(scope.row)">提现记录</el-button>
              <el-button class="flex-item" size="mini" @click="payVIPHis(scope.row)">购买记录</el-button>
              <el-button class="flex-item" size="mini" @click="rechage(scope.row)">充值记录</el-button>
              <el-button class="flex-item" size="mini" @click="statSettlement(scope.row)">结算账单</el-button>
              <el-button
                class="flex-item"
                size="mini"
                @click="subDisc(scope.row)"
              >下级代理({{scope.row.childCount}})</el-button>
              <div></div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--  下级代理弹窗 -->
    <sub-disc ref="subDisc"></sub-disc>
    <!--编辑tag弹窗-->
    <edit-district ref="editDistrict" @handlerDistrictList="getDistrictList"></edit-district>
    <!--新增tag弹窗-->
    <add-district ref="addDistrict" @handlerAddDistrict="getDistrictList()"></add-district>
    <rechage-popup ref="rechage"></rechage-popup>
    <widthdraw-popup ref="widthdraw"></widthdraw-popup>
    <!--查看分享链接-->
    <link-popup ref="linkPopup"></link-popup>
    <PayHisPopup ref="payHisPopup"></PayHisPopup>
    <StatDialy ref="statDialy"></StatDialy>
    <StatSettlement ref="statSettlement"></StatSettlement>
  </div>
</template>
<script>
import editDistrict from "./components/editPage/editDistrict";
import addDistrict from "./components/addDistrict";
import RechagePopup from "./components/rechagePopup";
import WidthdrawPopup from "./components/widthdrawPopup";
import LinkPopup from "./components/linkPopup";
import PayHisPopup from "./components/payHisPopup";
import StatDialy from "./components/statDialy";
import StatSettlement from "./components/statSettlement";
import SubDisc from "./components/subDisc";
import API from "@/api";
export default {
  data() {
    return {
      param: "",
      // 列表数据
      text: "",
      loading: false,
      total: 0,
      tableData: [],
      // 是否显示子渠道
      checked: false,
      params: {
        parent: "",
        pageNumber: 1,
        pageSize: 10,
        districtCode: "",
        name: "",
      },
      discTypeList: [
        { label: "CPS", value: 0 },
        { label: "CPA", value: 1 },
        { label: "CPT", value: 2 },
        { label: "CPC", value: 3 },
      ],
    };
  },
  filters: {
    handleFilterDiscType(params) {
      if (params === undefined || params === "") {
        return;
      }
      switch (params) {
        case 0:
          return "CPS";
        case 1:
          return "CPA";
        case 2:
          return "CPT";
        case 3:
          return "CPC";
      }
    },
    deductionType(params) {
      if (params === undefined || params === "") {
        return;
      }
      const dedUser = 2;
      const dedRecharge = 8;
      let text = [];
      if (params & dedUser) {
        text.push("扣用户");
      }
      if (params & dedRecharge) {
        text.push("扣充值");
      }
      if (text.length === 0) {
        return "不扣量";
      }
      return text.join("和");
    },
  },
  components: {
    editDistrict,
    addDistrict,
    RechagePopup,
    WidthdrawPopup,
    LinkPopup,
    PayHisPopup,
    StatDialy,
    StatSettlement,
    SubDisc,
  },
  created() {
    this.getDistrictList();
  },
  methods: {
    // 获取商区代理列表
    getDistrictList(type) {
      this.loading = true;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.params.parent = this.checked ? "" : "ZERO_VALUE";
      API.getDistrictList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getDistrictList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getDistrictList();
    },
    // 禁用商区代理
    ban(row) {
      let params = { id: row.id, enable: row.disable };
      let t = row.disable ? "启用" : "禁用";
      let sucMsg = {
        message:
          "[商区: " + row.districtCode + "] " + t + "登陆、提现、结算功能成功",
        type: "success",
      };
      this.$confirm(
        "您确定要" + t + "当前代理的登陆、提现、结算功能吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          API.disDistrict(params).then((res) => {
            if (res.code === 200) {
              this.$message(sucMsg);
            } else {
              if (res.tip) {
                this.$message.error(this.tip);
              } else {
                this.$message.error("操作失败！");
              }
            }
            this.getDistrictList();
          });
        })
        .catch(() => {});
    },
    // 删除
    remove(id) {
      this.$confirm("您确定要删除这条商区信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.delDistrict({ id: id }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getDistrictList();
            } else {
              if (res.tip) {
                this.$message.error(res.tip);
              } else {
                this.$message.error("删除失败");
              }
            }
          });
        })
        .catch(() => {});
    },
    //修改商区代理
    Action(data) {
      this.$refs.editDistrict.open(data);
    },
    // 新增商区代理
    addDistrict() {
      this.$refs.addDistrict.open();
    },
    // 查看上去代理充值列表
    rechage(row) {
      this.$refs.rechage.open(row);
    },
    // widthdraw
    widthdraw(row) {
      this.$refs.widthdraw.open(row);
    },
    // 查看邀请链接
    showLink(row) {
      this.$refs.linkPopup.open(row);
    },
    payVIPHis(row) {
      this.$refs.payHisPopup.open(row);
    },
    statDialy(row) {
      this.$refs.statDialy.open(row);
    },
    statSettlement(row) {
      this.$refs.statSettlement.open(row);
    },
    subDisc(row) {
      this.$refs.subDisc.open(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.operating {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  .flex-item {
    margin-top: 2px;
  }
  .flex-item:nth-type-of(1),
  .flex-item:nth-type-of(2) {
    margin-top: 0;
  }
}
</style>

<style lang="scss"></style>
